import { isPlainObject } from 'lodash';
import { ok } from 'assert';
import { stringify, parse } from 'qs';
import { result } from './symbols';
import { ControlFields } from './controlplane';
import { registry } from './registry';
import { InstanceGuard } from './guards';
import { on, set } from './accessors';
const pick = (data, props) => {
    return props.reduce((acc, prop) => Object.assign(acc, { [prop]: data[prop] }), {});
};
export function construct(Model, props = {}) {
    props = props || {};
    let instance = registry.get(Model, props);
    if (!instance) {
        instance = InstanceGuard(Model, props, () => new Model(props));
        proxy(instance);
        registry.set(Model, props, instance);
    }
    return instance;
}
function proxy(model) {
    Object.keys(model).forEach(key => {
        const descriptor = Object.getOwnPropertyDescriptor(model, key);
        if (descriptor && 'value' in descriptor && descriptor.value === undefined) {
            Object.defineProperty(model, key, {
                enumerable: true,
                configurable: true,
                get() {
                    return this[result] && this[result][key];
                }
            });
        }
    });
}
export function sign(params) {
    return stringify(params, {
        allowDots: true,
        arrayFormat: 'repeat',
        strictNullHandling: true,
        sort: (a, b) => a.localeCompare(b)
    });
}
sign.parse = function (sign) {
    return parse(sign, {
        allowDots: true,
        strictNullHandling: true,
    });
};
export function map(props, Class) {
    props = [].concat(props);
    ok(props.length, 'Unable remap collection by empty props list');
    function decorator(descriptor) {
        const { key } = descriptor;
        descriptor.initializer = function () {
            const target = this;
            ok(typeof key === 'string', `Unable to decorate non string property ${String(key)}`);
            on(target, ControlFields.Result, (result) => {
                if (!result) {
                    return;
                }
                const list = result[key];
                ok(Array.isArray(list), `Unable to remap non array property ${key}`);
                list.forEach((item) => {
                    if (Class.is(item)) {
                        return;
                    }
                    ok(isPlainObject(item), `Unable to remap not plain object ${key}`);
                    set(construct(Class, pick(item, props)), item);
                });
            });
        };
    }
    return decorator;
}
